export default function(){
	const testimonialsPictures = document.querySelectorAll( '[data-testimonial-picture]' )

	if ( testimonialsPictures.length > 0 ) {
		/* Set the height of the text as the height of the bigger text */
		const allTextBlocks = document.querySelectorAll( '[data-testimonial-text]' )

		if ( allTextBlocks.length > 0 ) {
			let biggerBlockHeight = 0

			allTextBlocks.forEach(text => {
				if ( text.clientHeight > biggerBlockHeight ) {
					biggerBlockHeight = text.clientHeight
				}
			});

			allTextBlocks.forEach(text => {
				text.style.height = biggerBlockHeight + 'px'

				if ( text.dataset.testimonialText != 1 ){
					text.classList.add('hidden')
				}
			});
		}


		/* Mouse events */
		testimonialsPictures.forEach(picture => {
			picture.addEventListener("mouseenter", () => {
				let index = picture.dataset.testimonialPicture

				/* Images: Control the active state */
				let allPictures = document.querySelectorAll( '[data-testimonial-picture]' )
				
				if ( allPictures.length > 0 ) {
					allPictures.forEach(picture => {
						if ( picture.dataset.testimonialPicture == index ) {
							picture.classList.add( 'active' )
						} else {
							picture.classList.remove( 'active' )
						}
					});
				}
				

				/* Quotes: Control which one is visible */
				let allQuotes = document.querySelectorAll( '[data-testimonial-text]' )
				
				if ( allQuotes.length > 0 ) {
					allQuotes.forEach(quote => {
						if ( quote.dataset.testimonialText == index ) {
							quote.classList.remove( 'hidden' )
						} else {
							quote.classList.add( 'hidden' )
						}
					});
				}
			});
		});
	}
}